import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);
  const privacyCopy = t('legal.privacy', {});
  const sections = Array.isArray(privacyCopy.sections) ? privacyCopy.sections : [];

  return (
    <section id="privacy-policy" className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <h2 className="text-3xl sm:text-4xl font-bold text-red-500 mb-8 text-center">
            {privacyCopy.title || 'Privacy Policy'}
          </h2>
          
          {/* Collapsible Privacy Policy Content */}
          <div className="bg-white rounded-2xl border-2 border-red-500">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="w-full p-6 sm:p-8 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
            >
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900">
                {privacyCopy.summaryTitle || privacyCopy.title || 'Privacy Policy'}
              </h3>
              <svg
                className={`w-6 h-6 text-gray-500 transition-transform duration-200 ${
                  isExpanded ? 'rotate-180' : ''
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            
            {isExpanded && (
              <div className="px-6 sm:px-8 pb-6 sm:pb-8">
                <div className="prose prose-lg max-w-none">
              <p className="text-sm text-gray-600 mb-6">
                <strong>{t('legal.common.lastUpdatedLabel')}</strong> {privacyCopy.lastUpdated}
              </p>
              
              {sections.map((section, index) => (
                <div key={`${section.title}-${index}`} className="mb-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">{section.title}</h3>
                  <p className="text-gray-700">{section.body}</p>
                </div>
              ))}
              
              {privacyCopy.contact && (
                <>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">{privacyCopy.contact.title}</h3>
                  <p className="text-gray-700 mb-6">
                    {privacyCopy.contact.description}
                  </p>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <p className="text-gray-700">
                      <strong>{t('legal.common.email')}</strong> {privacyCopy.contact.email}<br/>
                      <strong>{t('legal.common.phone')}</strong> {privacyCopy.contact.phone}<br/>
                      <strong>{t('legal.common.address')}</strong> {privacyCopy.contact.address}
                    </p>
                  </div>
                </>
              )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy; 